export default function LangList() {
  return (
    <>
      <data id="data-lang">{`en	ko	zh	ja	de	fr	es	hi	ar	pt	ru
English/영어/英語/en	Korean/한국어/韓語/ko	Chinese/중국어(번체)/中文/zh	Japanese/일본어/日語/ja	deutsche Sprache/독일어/Deutsch/de	Français/French/프랑스어/佛語/fr	Español/Spanish/스페인어/西班牙語/es	हिन्दी/Hindi/힌디어/印地语/hi	اللغة العربية/ar	Português/Portuguese/포르투갈어/葡萄牙語/pt	Русский/Russian/러시아어/俄語/ru`}</data>
      <div id="choose-lang-list" style={{ display:'none'}}>
      </div>
      <div className="cBoth"></div>
      <div className="side2" style={{padding:'1em'}}></div>
    </>
  );
}